module.exports = __webpack_public_path__ + "img/double-arrow-right.c70cdc30.svg";